export const sendCoinRoutes = [
  {
    path: 'wallet/send/coin',
    name: 'send_coin',
    component: () => import('@/views/dashboard/send/coin/SendCoinMain.vue'),
    children: [
      {
        path: ':walletId/select_account',
        name: 'send_coin_select_account',
        component: () =>
          import('@/views/dashboard/send/coin/SelectAccount.vue'),
        meta: {
          PageTitle: 'initial_screen.emphasis',
        },
      },
      {
        path: 'fee_routing',
        name: 'send_coin_fee_routing',
        component: () =>
          import(
            '@/views/dashboard/send/coin/branches/FeeRoutingMiddleware.vue'
          ),
        meta: {
          PageTitle: 'my_wallet.send',
        },
      },
      {
        path: 'set_amount',
        name: 'send_coin_set_amount',
        component: () => import('@/views/dashboard/send/coin/SetAmount.vue'),
        meta: {
          PageTitle: 'my_wallet.send',
        },
      },
      {
        path: 'confirmation',
        name: 'send_coin_confirmation',
        component: () => import('@/views/dashboard/send/coin/ConfirmCoin.vue'),
        meta: {
          PageTitle: 'my_wallet.send',
        },
      },
      {
        path: 'input_pin',
        name: 'send_coin_input_pin',
        component: () => import('@/views/dashboard/send/coin/SendCoinPin.vue'),
        meta: {
          PageTitle: 'my_wallet.send',
        },
      },
    ],
  },
  {
    path: 'wallet/:walletId/send/coin',
    name: 'wallet_send_coin',
    component: () => import('@/views/dashboard/send/coin/SendCoinMain.vue'),
    children: [
      {
        path: 'destination-select',
        name: 'send_coin_destination',
        component: () => import('@/views/dashboard/send/InputDestination.vue'),
        meta: {
          PageTitle: 'my_wallet.send',
        },
      },
    ],
  },
  {
    path: 'wallet/send/coin/network_fee',
    name: 'send_coin_network_fee',
    component: () =>
      import('@/views/dashboard/send/coin/branches/SelectNetworkFee.vue'),
    meta: {
      PageTitle: 'my_wallet.send',
    },
  },
  {
    path: 'wallet/send/coin/custom_fee_evm',
    name: 'send_coin_network_custom_fee_evm',
    component: () =>
      import('@/views/dashboard/send/coin/branches/CustomNetworkFee.vue'),
    meta: {
      PageTitle: 'my_wallet.send',
    },
  },
  {
    path: 'wallet/send/coin/complete',
    name: 'send_coin_complete',
    component: () =>
      import('@/views/dashboard/send/coin/branches/SendCoinComplete.vue'),
    meta: {
      PageTitle: 'my_wallet.send',
    },
  },
]
